import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Table, Input, Label, Card, CardHeader, CardBody, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import { useProfile } from "../../Components/Hooks/UserHooks";
import Loader from "../../Components/Common/Loader";
import Swal from 'sweetalert2';
const config = require('../../config.json');
const ProjectQuestions = () => {
    document.title = "Project Questions | ZWC";
    const { userProfile, loading, token } = useProfile();
    const [modal_list, setmodal_list] = useState(false);
    const [modal_edit, setmodal_edit] = useState(false);
    const [data, setData] = useState({});
    const [dissortBy, setdissortBy] = useState(null);
    const [disable, setdisable] = useState(false);
    const dissortbyname = [
        {
            options: [
                { label: "London", value: "London" },
                { label: "Manchester", value: "Manchester" },
                { label: "Liverpool", value: "Liverpool" }
            ]
        },
    ];

    const username = [
        {
            options: [
                { label: "Alabama", value: "AL" },
                { label: "Madrid", value: "MA" },
                { label: "Toronto", value: "TO" },
                { label: "Londan", value: "LO" },
                { label: "Wyoming", value: "WY" }
            ],
        },
    ];
    const tog_list = () => {
        setmodal_list(!modal_list);
    };
    const edit_company = () => {
        setmodal_edit(!modal_edit);
    };

    const set_update = (json) => {
        setmodal_edit(true);
    }

    const start = (id, ph) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to start this " + ph + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, do it!'
        }).then((result) => {
            toast.success("Project Phase" + ph + " Started Successfully", { autoClose: 3000 });
        })
    }
    const handelTeam = useCallback(() => {
        let axiosConfig = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}company/get_all_companys`,
            headers: {
                'Content-Type': 'application/json'
            },
        };
        axios.request(axiosConfig)
            .then((response) => {
                console.log(response)
                setData(response);
            })
            .catch((error) => {
                console.log(error);
                toast.error(`Error : ${error.response?.data?.message || error.message}`);
            });
    })
    useEffect(() => {
        //handelTeam()
    }, [userProfile])
    return (
        (false) ? <Loader /> :
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Project User Mapping" pageTitle="Zwc" />
                        <Row>
                            <Col xs={12}>
                                <Card>
                                    <CardHeader className='bg-success-subtle'>
                                        <Row >
                                            <Col className="col-12">
                                                <div>
                                                    <h4 className="card-title mb-0">Select Project for Location</h4>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col className='col-5'>
                                                <label htmlFor="companyName" className="form-label">Select Project</label>
                                                <Select
                                                    value={dissortBy}
                                                    onChange={(sortBy) => {
                                                        setdissortBy(sortBy);
                                                    }}
                                                    options={dissortbyname}
                                                    className="js-example-disabled mb-0"
                                                    isDisabled={disable}
                                                />
                                            </Col>
                                            {/* <Col className='col-5'>
                                                <label htmlFor="companyName" className="form-label">Select Project Loaction</label>
                                                <Select
                                                    value={dissortBy}
                                                    onChange={(sortBy) => {
                                                        setdissortBy(sortBy);
                                                    }}
                                                    options={dissortbyname}
                                                    className="js-example-disabled mb-0"
                                                    isDisabled={disable}
                                                />
                                            </Col> */}
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Card>
                                    <CardHeader className='bg-success-subtle'>
                                        <Row >
                                            <Col className="col-sm-auto">
                                                <div>
                                                    <h4 className="card-title mb-0">Project Question Details</h4>
                                                </div>
                                            </Col>
                                            <Col className="col-sm">
                                                <div className="d-flex justify-content-sm-end">
                                                    <Button color="info" className="add-btn me-1 rounded-pill" size='sm' onClick={() => tog_list()} id="create-btn"><i className="ri-add-line align-bottom me-1"></i> Add</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <div className="table-responsive">
                                            <Table className="align-middle table-nowrap mb-0 table-sm table-hover">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Sr No</th>
                                                        <th scope="col">Project Name</th>
                                                        <th scope="col">Questions</th>
                                                        <th scope="col">Exampale</th>
                                                        <th scope="col">Is Mandatory</th>
                                                        <th scope="col">Is Loaction Based</th>
                                                        <th scope="col">Loaction Name</th>
                                                        <th scope="col">Loaction Address </th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td scope="row">#1</td>
                                                        <td>Project Name</td>
                                                        <td>Full questions</td>
                                                        <td>Examples of Question</td>
                                                        <td><span className="badge bg-success">Yes</span></td>
                                                        <td><span className="badge bg-success">Yes</span></td>
                                                        <td>Location Name</td>
                                                        <td>Location Address</td>
                                                        <td><Button color="info" className="rounded-pill" size='sm' onClick={() => set_update(1)} ><i className="ri-delete-bin-line"></i>Edit</Button></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                {/* Add Modal */}
                <Modal isOpen={modal_list} toggle={() => { tog_list(); }} centered size="lg" >
                    <ModalHeader className=" p-3 text-white" toggle={() => { tog_list(); }}> Add Question to Project </ModalHeader>
                    <form className="tablelist-form">
                        <ModalBody>
                            <Row>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="companyName" className="form-label">Project Name</label>
                                    <input type="text" id="companyName" className="form-control" />
                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="companyName" className="form-label">Is Mandatory</label>
                                    <select className="form-select">
                                        <option value={1} selected={true}>Yes</option>
                                        <option value={0} >No</option>
                                    </select>
                                </div>
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="companyName" className="form-label">Question</label>
                                    <input type="text" id="companyName" className="form-control" />
                                </div>
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="companyName" className="form-label">Exampale</label>
                                    <input type="text" id="companyName" className="form-control" />
                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="companyName" className="form-label">Is Location based</label>
                                    <select className="form-select">
                                        <option value={1} selected={true}>Yes</option>
                                        <option value={0} >No</option>
                                    </select>
                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="opration" className="form-label">Select Location </label>
                                    <Select
                                        value={dissortBy}
                                        onChange={(sortBy) => {
                                            setdissortBy(sortBy);
                                        }}
                                        options={dissortbyname}
                                        className="js-example-disabled mb-0"
                                        isDisabled={disable}
                                    />
                                </div>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <div className="hstack gap-2 justify-content-center text-center">
                                <button type="button" className="btn btn-light" onClick={() => setmodal_list(false)}>Close</button>
                                <button type="submit" className="btn btn-success" id="add-btn">Add Question to Project Now</button>
                                {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
                            </div>
                        </ModalFooter>
                    </form>
                </Modal>
                {/* Update Modal */}
                <Modal isOpen={modal_edit} toggle={() => { edit_company(); }} centered size="lg" >
                    <ModalHeader className=" opacity-50 p-3 text-white " toggle={() => { edit_company(); }}> Update Location of Project </ModalHeader>
                    <form className="tablelist-form">
                        <ModalBody>
                            <Row>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="companyName" className="form-label">Project Name</label>
                                    <input type="text" id="companyName" className="form-control" />
                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="companyName" className="form-label">Is Mandatory</label>
                                    <select className="form-select">
                                        <option value={1} selected={true}>Yes</option>
                                        <option value={0} >No</option>
                                    </select>
                                </div>
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="companyName" className="form-label">Question</label>
                                    <input type="text" id="companyName" className="form-control" />
                                </div>
                                <div className="mb-3 col-md-12">
                                    <label htmlFor="companyName" className="form-label">Exampale</label>
                                    <input type="text" id="companyName" className="form-control" />
                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="companyName" className="form-label">Is Location based</label>
                                    <select className="form-select">
                                        <option value={1} selected={true}>Yes</option>
                                        <option value={0} >No</option>
                                    </select>
                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="opration" className="form-label">Select Location </label>
                                    <Select
                                        value={dissortBy}
                                        onChange={(sortBy) => {
                                            setdissortBy(sortBy);
                                        }}
                                        options={dissortbyname}
                                        className="js-example-disabled mb-0"
                                        isDisabled={disable}
                                    />
                                </div>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <div className="hstack gap-2 justify-content-center text-center">
                                <button type="button" className="btn btn-light" onClick={() => setmodal_list(false)}>Close</button>
                                <button type="submit" className="btn btn-success" id="add-btn">Change Now</button>
                                {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
                            </div>
                        </ModalFooter>
                    </form>
                </Modal>
            </React.Fragment>
    );
};

export default ProjectQuestions;